module.exports = __webpack_public_path__ + "static/media/RecordingIconFailed.b9c6e1bc.svg";